import React, { useState } from 'react';
import { ANTI_RESUME } from '../data';
import { useIsMobile } from '../hooks/useIsMobile';

const SECTIONS = [
  { key: 'learning', label: "What I'm Still Learning", icon: '↗' },
  { key: 'drains', label: 'What Kind of Work Drains Me', icon: '↘' },
  { key: 'doDifferently', label: "What I'd Do Differently", icon: '↻' },
];

export default function AntiResume() {
  const [activeIdx, setActiveIdx] = useState(0);
  const isMobile = useIsMobile();

  return (
    <section id="anti-resume" style={{ padding: '100px 0', borderTop: '1px solid rgba(26,26,26,0.06)' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in" style={{ marginBottom: '56px' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.28em', color: 'var(--ink-mid)', textTransform: 'uppercase', marginBottom: '16px' }}>
            The Anti-Resume
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 1, letterSpacing: '-0.03em', marginBottom: '12px' }}>
            The Honest Part
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink-light)', fontWeight: 300, maxWidth: '520px', lineHeight: 1.7 }}>
            Resumes show the highlights. This shows the edges — what I'm working on, what I've learned the hard way, and where I'm headed.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '240px 1fr', gap: '0' }}>
          {/* Tabs — vertical on desktop, horizontal scroll on mobile */}
          <div style={{
            borderRight: isMobile ? 'none' : '1px solid rgba(26,26,26,0.08)',
            borderBottom: isMobile ? '1px solid rgba(26,26,26,0.08)' : 'none',
            display: isMobile ? 'flex' : 'block',
            overflowX: isMobile ? 'auto' : 'visible',
            marginBottom: isMobile ? '0' : '0',
          }}>
            {SECTIONS.map((section, i) => (
              <div
                key={section.key}
                onClick={() => setActiveIdx(i)}
                style={{
                  padding: isMobile ? '12px 16px' : '20px 24px 20px 0',
                  borderBottom: isMobile ? 'none' : '1px solid rgba(26,26,26,0.06)',
                  borderRight: isMobile ? '1px solid rgba(26,26,26,0.06)' : 'none',
                  cursor: 'crosshair',
                  transition: 'all 0.2s',
                  whiteSpace: isMobile ? 'nowrap' : 'normal',
                  flexShrink: isMobile ? 0 : undefined,
                }}
              >
                <div style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.15em',
                  color: activeIdx === i ? 'var(--ink)' : 'var(--ink-light)',
                  textTransform: 'uppercase', transition: 'color 0.2s',
                }}>
                  <span style={{ fontSize: '14px', color: activeIdx === i ? 'var(--accent)' : 'var(--ink-light)', transition: 'color 0.2s' }}>{section.icon}</span>
                  {section.label}
                </div>
                {activeIdx === i && !isMobile && (
                  <div style={{ width: '20px', height: '2px', background: 'var(--accent)', marginTop: '10px' }} />
                )}
                {activeIdx === i && isMobile && (
                  <div style={{ height: '2px', background: 'var(--accent)', marginTop: '6px' }} />
                )}
              </div>
            ))}
          </div>

          {/* Content */}
          <div style={{ paddingLeft: isMobile ? '0' : '60px', paddingTop: isMobile ? '24px' : '20px' }}>
            <div style={{
              fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: 600,
              color: 'var(--ink)', letterSpacing: '-0.02em', marginBottom: '24px',
            }}>
              {SECTIONS[activeIdx].label}
            </div>
            <div style={{
              fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 300,
              color: 'var(--ink-mid)', lineHeight: 1.85, maxWidth: '580px',
              borderLeft: '2px solid var(--accent)', paddingLeft: '24px',
            }}>
              {ANTI_RESUME[SECTIONS[activeIdx].key]}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
